import React from "react";
import { Link } from "react-router-dom";
import ServicePageTemplate from "./ServicePageTemplate";

const OfficeCleaningPage = () => {
  const pageData = {
    pageTitle: "Office Cleaning Cardiff | Reliable Office Cleaners | NeatWave",
    metaDescription: "Office cleaning in Cardiff, Barry and Penarth. Daily, weekly or fortnightly office cleaners working before or after hours. DBS-checked and fully insured. Request a free quote.",
    heroTitle: "Office Cleaning in Cardiff",
    heroSubtitle: "Dependable office cleaners who keep desks, kitchens and washrooms clean, on a schedule that fits around your working day.",
    heroImage: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjBjbGVhbmluZ3xlbnwwfHx8fDE3NzU5MDkwMDZ8MA&ixlib=rb-4.1.0&q=85",
    heroImageAlt: "Clean, bright open-plan office in Cardiff after a professional office clean",
    quoteService: "Commercial Cleaning",

    serviceDescription: (
      <>
        <p className="mb-4">
          A clean office makes a better first impression on clients and a healthier place for your team. NeatWave provides office cleaning in Cardiff for small offices, shared workspaces, agencies, clinics and professional practices, as well as offices in Barry and Penarth.
        </p>
        <h2>Office cleaners who work around you</h2>
        <p className="mb-4">
          Most offices prefer us to clean early in the morning or after staff leave, so there's no disruption to meetings or phone calls. We agree a written checklist with you at the start, so every visit covers the same tasks and nothing is left to chance.
        </p>
        <h3>Daily, weekly or fortnightly office cleaning</h3>
        <p className="mb-4">
          Busy offices with lots of visitors usually need daily cleaning, while smaller teams often choose two or three visits a week. We'll recommend a frequency based on your headcount, floor space and how heavily the kitchen and washrooms are used.
        </p>
        <h3>Security and trust</h3>
        <p className="mb-4">
          Our cleaners are DBS-checked and NeatWave is fully insured. We can work with key holders, alarm codes and access fobs, and we respect confidential paperwork on desks.
        </p>
        <p className="mb-4">
          Need more than office cleaning? See our wider <Link to="/commercial-cleaning-cardiff">commercial cleaning in Cardiff</Link> for shops and other workplaces, or book a one-off <Link to="/deep-cleaning-cardiff">deep clean</Link> before an inspection or office move.
        </p>
      </>
    ),

    includedTitle: "What Our Office Cleaning Covers",
    whatIncluded: [
      { title: "Desks & Workstations", description: "Dust and wipe clear desks, monitors, phones and keyboards, and empty bins and recycling" },
      { title: "Kitchens & Break Areas", description: "Worktops, sinks, microwaves, fridge exteriors, tables and floors" },
      { title: "Washrooms", description: "Toilets, basins, mirrors and floors cleaned and sanitised, and consumables topped up on request" },
      { title: "Reception & Meeting Rooms", description: "Front desk, seating, glass doors and meeting tables kept presentable for visitors" },
      { title: "Floors", description: "Vacuum carpets and mop hard floors, paying attention to entrances and high-traffic walkways" },
      { title: "Touch Points", description: "Door handles, light switches, lift buttons and handrails wiped down every visit" },
    ],

    pricingInfo: {
      duration: "Scheduled to suit you",
      price: "From £80",
      note: "Office cleaning prices depend on floor area, number of washrooms and kitchens, and how often you need us. Request a free quote and we'll confirm a fixed price for your office.",
    },

    faqs: [
      { q: "Do you provide office cleaning in Cardiff outside working hours?", a: "Yes. We can clean early mornings, evenings or weekends so your office is ready when your team arrives, with no disruption during the working day." },
      { q: "How often should an office be cleaned?", a: "It depends on how many people use the space. Busy offices usually need daily cleaning, while smaller teams often choose two or three visits a week. We'll suggest a schedule when we quote." },
      { q: "Do you bring cleaning products and equipment?", a: "Yes. We bring professional products and equipment. If you prefer specific products, we're happy to use them." },
      { q: "Can you clean offices in Barry and Penarth?", a: "Yes. As well as Cardiff, we clean offices and workplaces in Barry and Penarth." },
      { q: "How do I get an office cleaning quote?", a: "Use our quote calculator, call 0749 286 5011 or message us on WhatsApp. Tell us your office size, number of washrooms and how often you need cleaning." },
    ],

    testimonial: {
      text: "The service was excellent, professional, and reliable, with great attention to detail. I would confidently recommend NeatWave Cleaning Services to anyone looking for quality cleaning services.",
      author: "Elvis Madu, Google review",
    },

    relatedServices: [
      { title: "Commercial Cleaning", description: "Cleaning for shops, workplaces and commercial premises", url: "/commercial-cleaning-cardiff" },
      { title: "Deep Cleaning", description: "A one-off intensive clean before inspections or moves", url: "/deep-cleaning-cardiff" },
      { title: "Carpet Cleaning", description: "Hot water extraction for office carpets", url: "/carpet-cleaning-cardiff" },
    ],
  };

  return <ServicePageTemplate {...pageData} />;
};

export default OfficeCleaningPage;
